import { render, staticRenderFns } from "./e-badge-item.vue?vue&type=template&id=38670963&scoped=true"
import script from "./e-badge-item.vue?vue&type=script&lang=js"
export * from "./e-badge-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38670963",
  null
  
)

export default component.exports